import {createAction, props} from "@ngrx/store";
import {RegisterUserDto} from "@server-models";

interface IRegisterGuestPayload {
  isRetry: boolean;
  email: string;
  passwordBase64: string;
}

export const initRegistrationGuest = createAction(
  '[Tech Register] Registration Guest Start',
  props<{ isLoadingId?: number | string, currentEmail: string | undefined }>()
);

export const initRegistrationGuestDialogOpen = createAction(
  '[Tech Register] Registration Guest Dialog Open',
  props<{ currentEmail: string | undefined }>()
);

export const initRegistrationGuestDialogClose = createAction(
  '[Tech Register] Registration Guest Dialog Close'
);

export const initRegistrationGuestSuccess = createAction(
  '[Tech Register] Registration Guest Success'
);

export const initRegistrationGuestFail = createAction(
  '[Tech Register] Registration Guest Fail',
  props<{ error: any }>()
);

export const registerGuestPinRequest = createAction(
  '[Tech Register] Guest Pin Request Start',
  props<{ registerGuest: IRegisterGuestPayload, isLoadingId?: number | string }>()
);

export const registerGuestPinRequestSuccess = createAction(
  '[Tech Register] Guest Pin Request Success',
  props<IRegisterGuestPayload>()
);

export const registerGuestPinRequestFail = createAction(
  '[Tech Register] Guest Pin Request Fail',
  props<{ error: any }>()
);

export const registerGuestPinDialog = createAction(
  '[Tech Register] Guest Pin Dialog Start',
  props<any>()
);

export const registerGuestPinDialogCancel = createAction(
  '[Tech Register] Guest Pin Dialog Cancel'
);

export const registerGuestAsUser = createAction(
  '[Tech Register] Guest As User Start',
  props<{ data: RegisterUserDto, isLoadingId: number | string, isRetry?: boolean }>()
);

export const registerGuestAsUserSuccess = createAction(
  '[Tech Register] Guest As User Success',
  props<IRegisterGuestPayload>()
);

export const registerGuestAsUserFail = createAction(
  '[Tech Register] Guest As User Fail',
  props<{ error: any }>()
);
